import { useEffect, useState } from 'react'
import { PrismicPreview } from '@prismicio/next'
import { repositoryName } from 'prismicio'
import { ReactFC } from 'common/types/ReactFC'

type ComponentType = {}

const PrismicScript: ReactFC<ComponentType> = ({ children }) => {
  const [isActive, setIsActive] = useState<boolean>(false)
  useEffect(() => {
    fetch('/api/prismic')
      .then((r) => r.text())
      .then((res) => {
        if (res) {
          setIsActive(true)
        }
      })
  }, [])
  if (isActive) {
    return (
      <PrismicPreview repositoryName={repositoryName}>
        {children}
      </PrismicPreview>
    )
  }

  return <>{children}</>
}

export default PrismicScript
